import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'

import * as fromProjectorTemplates from './+state/projector-templates.reducer'
import { ProjectorTemplatesEffects } from './+state/projector-templates.effects'
import { ProjectorTemplatesFacade } from './+state/projector-templates.facade'

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromProjectorTemplates.PROJECTOR_TEMPLATES_FEATURE_KEY,
      fromProjectorTemplates.projectorTemplatesReducer,
    ),
    EffectsModule.forFeature([ProjectorTemplatesEffects]),
  ],
  providers: [ProjectorTemplatesFacade],
})
export class GbDashboardPresenterDataAccessProjectorTemplatesModule {}
